import { AfterViewInit, Component, EventEmitter, Input } from '@angular/core';
import { IModalComponent } from '@lib/modal';
import { EMediaDevices } from '@core/services';
import { monitorLogger } from '../../../../project/monitor/monitor-logger';

@Component({
  selector: 'app-ask-for-media-devices-overlay',
  templateUrl: './ask-for-media-devices-overlay.component.html',
  styleUrls: ['./ask-for-media-devices-overlay.component.scss'],
})
export class AskForMediaDevicesOverlayComponent implements IModalComponent, AfterViewInit {
  @Input() mediaDeviceToAsk: EMediaDevices = null;

  public readonly mediaDevices = EMediaDevices;

  public submit$ = new EventEmitter();
  public close$ = new EventEmitter();

  ngAfterViewInit() {
    monitorLogger.screen.trackScreen('ask-for-media-devices-overlay', 'tela_permitir_camera_microfone');
  }

  public onCancelClick(): void {
    monitorLogger.screen.trackScreen('ask-for-media-devices-overlay', 'clicar_botao_cancelar');
    this.close$.emit();
  }
}
